import Translate from 'src/language/Translate';
import { Icon } from '@iconify/react';
import googleFill from '@iconify/icons-eva/google-fill';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Grid, Link, Divider, Container, Typography, IconButton, Stack } from '@material-ui/core';
// routes
import { PATH_PAGE } from '../../routes/paths';
//
import Logo from '../../components/Logo';
import i18n from 'i18next';

let setlang = i18n.language;

// ----------------------------------------------------------------------

// const SOCIALS = [
//   { name: 'FaceBook', icon: facebookFill },
//   { name: 'Google', icon: googleFill },
//   { name: 'Linkedin', icon: linkedinFill },
//   { name: 'Twitter', icon: twitterFill }
// ];

const LINKS = [
  {
    headline: Translate('Info'),
    children: [
      { name: Translate('Pobierz aplikację'), href: '/apps' },
      { name: Translate('Regulamin korzystania z usług'), blanck: true, href: 'https://api.asystent.biz/'+setlang+'/pages/regulamin-korzystania-z-uslug-web' },
      { name: Translate('Polityka prywatności'), blanck: true, href: 'https://api.asystent.biz/'+setlang+'/pages/polityka-prywatnosci-web' },
      // { name: 'Regulamin konkursu', blanck: true, href: 'https://api.asystent.biz/'+setlang+'/pages/regulamin-konkursu-web' },
      { name: Translate('Informacja o cookies'), blanck: true, href: 'https://api.asystent.biz/'+setlang+'/pages/informacja-o-cookies' },
      { name: Translate('Jak nagrać video CV'), blanck: false, href: '/news/wskazowki-dotyczace-tworzenia-video-cv' },
      { name: Translate('Oferty pracy'), href: "//asystentbiz.recruitify.ai/jobs", islink: true },
    ]
  },
  {
    headline: Translate('MENU'),
    children: [
      { name: Translate('O nas'), href: PATH_PAGE.about },
      { name: Translate('Dla pracodawcy'), href: PATH_PAGE.forcompanies },
      { name: Translate('Szkolenia'), href: '/courses' },
      { name: Translate('FAQs'), href: PATH_PAGE.faqs },
      { name: Translate('Blog'), href: PATH_PAGE.news },
      { name: Translate('Kontakt'), href: PATH_PAGE.contact },
    ]
  },
  {
    headline: '',
    children: []
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

let isNews = false
if (window.location.href.indexOf("news") > -1) {
  isNews = true
}

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          {/* <Grid item xs={12} sx={{ mb: 3 }}>
            
          </Grid> */}
          <Grid item xs={8} md={3} className="footerItem">
            <ScrollLink to="move_top" spy smooth>
              <div className="logoBox" style={{marginBottom:20}}><Logo sx={{ mx: { xs: 'auto', md: 'inherit' },width: 35 }} /></div>
            </ScrollLink>
            <Typography variant="body2" sx={{ pr: 0, md: 5 }}>
              { isNews ? (<>
                {Translate("Informacje zostały zebrane z otwartych źródeł, przetworzone przez naszych specjalistów i opublikowane na stronie. Wszelkie ponowne publikacje są dozwolone, ponieważ dzielimy się wiedzą – a wiedza dla tych, którzy chcą wiedzieć, powinna być dostępna.")}
              </>) : (<>
                {Translate("Dołącz do społeczności asystent.biz")}<br/>
                {Translate("Z łatwością stwórz swoje video CV online")}<br/>
                {Translate("za pomocą naszej aplikacji")}.<br/>
                {Translate("Wypełnij klasyczne CV i otrzymaj ofertę pracy")}<br/>
                {Translate("zgodnie ze swoimi oczekiwaniami")}.
              </>)}
            </Typography>

            {/* <Stack
              spacing={1.5}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              {SOCIALS.map((social) => (
                <IconButton key={social.name} color="primary" sx={{ p: 1 }}>
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack> */}
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component="p" variant="overline" style={{color: "#21bfeb"}}>
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <div key={link.name}>
                      {link.islink!=true ? (
                      <span>{link.blanck==true ? (
                        <Link
                          target={link.blanck==true && "_blank"}
                          href={link.href}
                          key={link.name}
                          color="inherit"
                          variant="body2"
                          sx={{ display: 'block' }}
                        >
                          {link.name}
                        </Link>
                      ) : (
                        <Link
                          to={link.href}
                          key={link.name}
                          color="inherit"
                          variant="body2"
                          component={RouterLink}
                          sx={{ display: 'block' }}
                        >
                          {link.name}
                        </Link>
                      )}</span>
                      ) : (
                        <a href={link.href} className="MuiTypography-root MuiTypography-body2 MuiLink-root MuiLink-underlineHover LinkFooterRoot" target="_blanck">{link.name}</a>
                      )}
                      </div>
                    ))}
                  </Stack>
                );
              })}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          {Translate("© 2021-2022 asystent.biz • All rights reserved")}
        </Typography>
      </Container>
    </RootStyle>
  );
}
